import { AssetInfoDetails } from 'BreetComponents';
import { useRateCalculatorContext } from 'BreetHooks';

import AssetDetailsQR from './AssetDetails.QR';
import AssetDetailsTransactionInfo from './AssetDetails.TransactionInfo';

const AssetDetails = () => {
	const { selectedAsset } = useRateCalculatorContext();

	const walletIntro = `Receive only ${selectedAsset?.name} (${selectedAsset?.identifier}) to this address to get the equivalent in Naira or USD — other assets may be lost. `;

	return (
		<div className='rate-calculator-asset-details'>
			<AssetInfoDetails
				selectedAsset={selectedAsset}
				walletIntro={walletIntro}
				hideNetworkSelection
			/>
			<AssetDetailsQR selectedAsset={selectedAsset} />
			<AssetDetailsTransactionInfo selectedAsset={selectedAsset} />
		</div>
	);
};

export default AssetDetails;
